export * from './NarrowMediaAndBottomText';
